import Communication from "./Communication.container";

export default Communication;